<template>
  <div class="home" :style="isshowlogin?'height:100vh;overflow:hidden':''">
    <Header :isbig="true" @changeLogin="changeLogin"></Header>
    <div class="homeCon">
      <div class="section section1">
        <img :src="require(`@/assets/home/home_${$i18n.locale}_img1.png`)">
        <div class="center">
          <a class="app-box" @click="handleShow('ios')" @blur="showIos = false" :tabindex="0" :outline="0" :hidefocus="true">
            <img src="@/assets/home/ios.png">
            <span>ios</span>
            <div class="download-wrap" v-show="showIos">
              <img src="@/assets/home/NovelShort_logo.png" @click="downloadApp('ios_NovelShort')">
              <img src="@/assets/home/Pureshort_logo.png" @click="downloadApp('ios_Pureshort')">
              <img src="@/assets/home/Inktale_logo.png" @click="downloadApp('ios_Inktale')">
            </div>
          </a>
          <a class="app-box" @click="handleShow('android')" @blur="showAndroid = false" :tabindex="0" :outline="0" :hidefocus="true">
            <img src="@/assets/home/android.png">
            <span>Android</span>
            <div class="download-wrap" v-show="showAndroid">
              <img src="@/assets/home/NovelShort_logo.png" @click="downloadApp('android_NovelShort')">
              <img src="@/assets/home/Pureshort_logo.png" @click="downloadApp('android_Pureshort')">
              <!-- <img src="@/assets/home/Adoread_logo.png" @click="downloadApp('android_Adoread')"> -->
            </div>
          </a>
        </div>
      </div>
      <div class="section section2">
        <img :src="require(`@/assets/home/home_img2.png`)">
      </div>
    </div>
    <Footer :big="true"></Footer>
    <Login @changeLogin="changeLogin" v-if="isshowlogin"></Login>
  </div>
</template>

<script>
import { getBookList, homeshelf } from "@/api/book";
import {getToken} from "../utils/storage";
export default {
  name: "home",
  data() {
    return {
      shelf1: [],
      shelf2: [],
      shelf3: [],
      showIos: false,
      showAndroid: false,
    };
  },
  created() {
    this.$nextTick(() => {
      // this.getIdShelf();
    });
  },
  methods: {
    handleShow(flag) {
      if (flag === 'ios') {
        this.showIos = !this.showIos;
        this.showAndroid = false;
      } else {
        this.showIos = false;
        this.showAndroid = !this.showAndroid;
      };
    },
    downloadApp(name) {
      let downloadData = {
        ios_NovelShort: 'https://apps.apple.com/app/id6502894256',
        ios_Pureshort: 'https://apps.apple.com/app/id6462087539',
        ios_Inktale: 'https://apps.apple.com/app/id6443915856',
        android_NovelShort: 'https://play.google.com/store/apps/details?id=com.novelshort.book',
        android_Pureshort: 'https://play.google.com/store/apps/details?id=com.adoread.book',
        android_Adoread: 'https://play.google.com/store/apps/details?id=com.procket.tv',
      };
      window.open(downloadData[name]);
    },
    // 获取推荐位
    getIdShelf() {
      homeshelf().then(res => {
        console.log(res)
        if (res.success) {
          this.shelf1 = res.data.shelves[0].content
          this.shelf2 = res.data.shelves[1].content
          this.shelf3 = res.data.shelves[2].content
        }
      });
    },
    goCreate () {
      this.$router.push('/Create/0')
    },
    gofuli () {
      this.$router.push('/welfare')
    }
  }
};
</script>

<style lang="scss" scoped>
  .home{
   width: 100%;
    .header{
      position: fixed;
      top: 0;
      z-index: 9;
  }
    .section{
      position: relative;
      width: 100%;
      &.section1{
        .center{
          position: absolute;
          bottom: 1.275rem;
          right: 5rem;
          width: 1.5rem;
          height: 2.95rem;
          background: #3C3C3C;
          border-radius: 10px;
          box-sizing: border-box;
          padding: .325rem .55rem;
          .app-box{
            margin-bottom: .475rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            >img{
              width: .4rem;
              height: .5rem;
            }
            >span{
              margin-top: .1rem;
              font-family: 'PingFangSC';
              font-weight: 500;
              font-size: .25rem;
              color: #FFFFFF;
              line-height: .3rem;
            }
            .download-wrap{
              position: absolute;
              right: 1.25rem;
              top: -0.5rem;
              padding: .325rem .325rem 0;
              box-sizing: border-box;
              background: #FFF;
              border-radius: .125rem;
              z-index: 1;
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              &::before{
                content: "";
                position: absolute;
                right: -0.1875rem;
                top: .625rem;
                border-style: solid;
                border-width: .1875rem 0 .1875rem .25rem;
                border-color: transparent transparent transparent #fff;
              }
              >img{
                width: 1.2rem;
                height: 1.2rem;
                margin-right: .325rem;
                margin-bottom: .325rem;
                &:nth-child(3n) {
                  margin-right: 0;
                }
                &:nth-last-child(1) {
                  margin-right: 0;
                }
              }
            }
          }
        }
      }
      img{
        width: 100%;
        height: 100%;
      }
    }
 }
</style>
